exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pop-cover[data-v-613ab030] {\n  position: relative;\n}\n.delete-popover[data-v-613ab030] {\n  position: absolute;\n  right: 32px;\n  padding: 10px;\n  border-radius: 4px;\n  width: 180px;\n  bottom: -30px;\n}\n", ""]);

// exports
